// mqttService.js
import mqtt from 'mqtt';

// ===== Debug switch (mets true pour débugger) =====
const DEBUG_MQTT = false;
const log  = (...a) => DEBUG_MQTT && console.log(...a);
const warn = (...a) => DEBUG_MQTT && console.warn(...a);
const error = (...a) => DEBUG_MQTT && console.error(...a);

// ===== URL WSS Mosquitto (⚠️ le chemin /mqtt est nécessaire) =====
const brokerUrl = 'wss://mqtt.lumieresdejardin.fr:8084/mqtt';

// ===== Options de connexion =====
const options = {
  username: 'sonoff_user',
  password: '12345678',
  clientId: 'webclient_' + Math.random().toString(16).slice(2, 10),
  clean: true,
  connectTimeout: 4000,
  reconnectPeriod: 1000,
  keepalive: 30,
  protocolVersion: 4, // MQTT 3.1.1
};

// ===== Singleton pour éviter plusieurs connexions (hot reload React) =====
let client;
if (typeof window !== 'undefined') {
  if (!window.__mqttClient) {
    window.__mqttClient = mqtt.connect(brokerUrl, options);
  }
  client = window.__mqttClient;
} else {
  client = mqtt.connect(brokerUrl, options);
}

// ===== Logs (pilotés par DEBUG_MQTT) =====
client.on('connect',   () => log('[MQTT][Service] Connecté (WSS:8084 /mqtt)'));
client.on('reconnect', () => log('[MQTT][Service] Reconnexion…'));
client.on('close',     () => warn('[MQTT][Service] Connexion fermée.'));
client.on('error',     (err) => error('[MQTT][Service] Erreur MQTT :', err?.message || err));

export default client;